// Helper to determine if a user is part of the Pflege-KI / PDL-Suite target audience.
// The DB field `user.profession` is set by the admin (or via signup form) and is one of
// the values in ALLOWED_PROFESSIONS (see backend admin_router.py).
//
// Adjust this list if new profession keys are introduced.
export const PFLEGE_KI_TARGET_ROLES = [
  'pdl',
  'leitung',
  'wbl',
  'praxisanleitung',
  'inhaber',
  'heimleitung',
];

export function isPflegeKiTarget(user) {
  if (!user) return false;
  const prof = String(user.profession || '').toLowerCase().trim();
  return PFLEGE_KI_TARGET_ROLES.includes(prof);
}
